import React, { useState } from 'react';
import treatmentsData from '../data/items';
import { ChevronDown, Hand, Stethoscope, Dumbbell, Zap, Waves, Heart, Radio } from 'lucide-react';
import './Treatments.css';

const Treatments = () => {
    const [expandedId, setExpandedId] = useState(null);

    const toggleTreatment = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    // Iconos temáticos para cada tratamiento
    const treatmentIcons = [
        Hand,        // Terapia Manual
        Stethoscope, // McKenzie
        Dumbbell,    // Ejercicio Terapéutico
        Zap,         // Punción Seca
        Waves,       // Fibrólisis
        Heart,       // Fisioterapia y mujer
        Radio        // Ecografía
    ];

    return (
        <div className="treatments-page">
            <div className="treatments-header">
                <h1>Nuestros Tratamientos</h1>
                <p>Soluciones personalizadas para tu recuperación y bienestar.</p>
            </div>

            <div className="container">
                <div className="treatments-timeline">
                    {treatmentsData.map((treatment, index) => {
                        const IconComponent = treatmentIcons[index] || Hand;

                        return (
                            <div
                                key={treatment.id}
                                className={`treatment-item ${expandedId === treatment.id ? 'expanded' : ''} ${index % 2 === 0 ? 'left' : 'right'}`}
                                onClick={() => toggleTreatment(treatment.id)}
                            >
                                <div className="treatment-image-wrapper">
                                    <img
                                        src={require(`../images/${treatment.image}`)}
                                        alt={treatment.title}
                                        className="treatment-img"
                                    />
                                </div>

                                <div className="treatment-icon-circle">
                                    <IconComponent size={28} />
                                </div>

                                <div className="treatment-info">
                                    <div className="treatment-header-row">
                                        <h3>{treatment.title}</h3>
                                        <ChevronDown className={`chevron ${expandedId === treatment.id ? 'rotated' : ''}`} size={24} />
                                    </div>

                                    <div className="treatment-description">
                                        <p>{treatment.content}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Treatments;
